import { render } from "./DashboardProfileButton.vue?vue&type=template&id=7b33f0c8&scoped=true"
import script from "./DashboardProfileButton.vue?vue&type=script&lang=ts"
export * from "./DashboardProfileButton.vue?vue&type=script&lang=ts"

import "./DashboardProfileButton.vue?vue&type=style&index=0&id=7b33f0c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b33f0c8"

export default script